import { memo } from 'react';
import { Text, Markdown, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import PermissionsPic from './PermissionsPic';

const PermissionsRequired = () => {
    const theme = useTheme();
    return (
        <div className="fm-ee__contentWrapper">
            <PermissionsPic />
            <Text type="subtitle1" color={theme.colors.utility.textPrimary}>
                {getLiteral('title_permission_request')}
            </Text>
            <Markdown
                content={getLiteral('label_permission_request_desc')}
                overrides={{ p: { type: 'caption', color: theme.colors.utility.textSecondary } }}
            />
        </div>
    );
};

export default memo(PermissionsRequired);
